import { useTranslation } from 'react-i18next'

import { CircleCheck } from '@/components/icons/CircleCheck'

export const ReminderBanner = () => {
  const { t } = useTranslation()
  return (
    <div className="bg-gray-background flex items-center gap-4 p-5 shadow-xs" data-testid="reminder-banner">
      <CircleCheck className="h-7 w-7 shrink-0" />
      <label> {t('reminder_set')}</label>
    </div>
  )
}
